import React, { useEffect, useState } from 'react';
import { getDocsURL } from "../../utilities";
import { Spinner } from 'react-bootstrap';
import { pdfjs } from 'react-pdf';
import axios from 'axios';
import styles from './index.module.css';

// Worker configuration for react-pdf v9
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

function Statedropdown({ }) {
  const [guidelinesData, setGuidelinesData] = useState();
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProgram, setSelectedProgram] = useState(null);

  const handlePDFSelection = (pdfLink) => {
    setSelectedPDF(pdfLink);
  };

  const handleProductSelection = (product) => {
    setSelectedProduct(product);
    setSelectedProgram(null);
  };

  const handleProgramSelection = (program) => {
    setSelectedProgram(program);
  };

  const handleDownload = (filename, itemName) => {
    const documentURL = getDocsURL(filename);
    window.open(documentURL, '_blank');

    // Trigger the download
    // downloadDocument(filename, itemName);
  };

  const toggleCategoryProducts = (categoryIndex) => {
    setGuidelinesData((prevData) => {
      const updatedData = prevData.map((item, index) => {
        if (index === categoryIndex) {
          return { ...item, showProducts: !item.showProducts };
        }
        return item;
      });
      return updatedData;
    });
  };

  useEffect(() => {
    const fetchGuidelinesData = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_SWMC_RETAILPRODUCTDPA_GUIDELINES,
        );
        setGuidelinesData(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchGuidelinesData();
  }, []);

  return (
    <article>
      <section className={styles.pageContainer}>
        {!guidelinesData ? (
          <div className={`d-flex justify-content-center mt-3 mb-3 ${styles.spinnerContainer}`}>
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <div className={styles.tableOfContentsContainer}>
            <div className={styles.tableOfContents}>
              {guidelinesData.map((category, categoryIndex) => (
                <div key={categoryIndex} className={styles.category}>
                  {category.redirectLink ? (
                    <h2 className={styles.redirectionLink}>
                      <a
                        href={category.redirectLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {category.title}
                      </a>
                    </h2>
                  ) : (
                    <div>
                      <h2
                        className={`${styles.dropdownIcon} ${category.showProducts ? styles.expanded : ''}`}
                        onClick={() => toggleCategoryProducts(categoryIndex)}
                      >
                        {category.title}
                      </h2>
                      <ul>
                        {category.showProducts &&
                          category.data.map((section, sectionIndex) => (
                            <div key={sectionIndex} className={styles.section}>
                              {section.products && (
                                <ul>
                                  {section.products.map((product, index) => (
                                    <li
                                      key={index}
                                      className={styles.pdfListItem}
                                    >
                                      <div className={styles.productName}>
                                        <div
                                          className={`${selectedProduct === product ? styles.selectedItem : ''}`}
                                          onClick={() => handleProductSelection(product)}
                                        >
                                          <span
                                            onClick={() => {
                                              if (product.programs && product.programs.length > 0) {
                                                product.showPrograms = !product.showPrograms;
                                                setGuidelinesData([...guidelinesData]);
                                                handlePDFSelection(product.filename);
                                              } else {
                                                handleDownload(product.filename, product.name);
                                              }
                                            }}
                                          >
                                            {product.name}
                                          </span>
                                        </div>
                                      </div>
                                      {product.showPrograms && (
                                        <ul className={styles.programList}>
                                          {product.programs.map(
                                            (program, programIndex) => (
                                              <li
                                                key={programIndex}
                                                className={styles.programListItem}
                                              >
                                                <div
                                                  className={styles.programItemchanged}
                                                >
                                                  {program.filename ? (
                                                    <div className={`${styles.programName} ${selectedProgram === program ? styles.selectedItem : ''}` }
                                                    onClick={() => handleProgramSelection(program)}
                                                    >
                                                      <span
                                                        onClick={() => {
                                                          handleDownload(
                                                            program.filename,
                                                            program.name,
                                                          );
                                                        }}
                                                      >
                                                        {program.name}
                                                      </span>
                                                    </div>
                                                  ) : (
                                                    <div className={styles.program} onClick={() => alert(program.message)}>
                                                      {program.name}
                                                    </div>
                                                  )}
                                                </div>
                                              </li>
                                            ),
                                          )}
                                        </ul>
                                      )}
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          ))}
                      </ul>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </section>
    </article>
  );
}

export default Statedropdown;
